export const SUBMISSION_RESPONSE =
  "Thank you for your submission.  We are processing your request and we'll get back to you shortly.  You will receive another notification when we are done reviewing.";

export const APPROVAL_CONFIRMATION =
  "Are you sure you want to approve your request?  You will no longer be able to edit this request once it is approved.";
